<div class="transpose-view">
    @if(eliteFormId && itemIds.length > 0) {
    <div class="transpose-table-container">
        <form [formGroup]="inputForm" class="transpose-grid-form">
            <table class="transpose-table">
                <thead>
                    <tr>
                        <th class="field-title-column">Field</th>
                        @for (itemIdKey of itemIds; track itemIdKey) {
                        <th class="section-column">
                            <div class="flex flex-row justify-between items-center">
                                <span>Section {{itemIds.indexOf(itemIdKey) + 1}}</span>
                                <button type="button"
                                    *ngIf="dialogField.fieldValues['IsMultiResponseField'] && !dialogField.fieldValues['IsMultiResponsePage'] && !dialogField.isDisabled"
                                    mat-icon-button class="delete-section-btn" matTooltip="Delete Section"
                                    (click)="deleteSection($event, itemIdKey)">
                                    <i class="fa-regular fa-trash"></i>
                                </button>
                            </div>
                        </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @if(platformDialogs && itemIds.length > 0 &&
                    platformDialogs[itemIds[0]][0]?.dialogDefinitions[0]?.fields) {
                    @for (field of platformDialogs[itemIds[0]][0].dialogDefinitions[0].fields; track field.key) {
                    <tr>
                        @if(field.type === 'Title' || field.type === 'Description') {
                        <td [attr.colspan]="itemIds.length + 1" class="field-name">
                            <particle-dynamic-html [content]="field.title"></particle-dynamic-html>
                            <div class="field-header">{{field.fieldValue || field.value}}</div>
                        </td>
                        } @else {
                        <td class="field-name">
                            <particle-dynamic-html [content]="field.title"></particle-dynamic-html>
                            <button mat-icon-button *ngIf="field.fieldValues['Details']" matTooltip="View Details"
                                class="icon-dropdown-button" (click)="openDetailsAndInstructions(field)"><i
                                    class="fa-regular fa-circle-info"></i>
                            </button>
                        </td>
                        @for (itemIdKey of itemIds; track itemIdKey) {
                        <td class="field-value-cell" [id] = "field.key + '--' + itemIdKey">
                            <div class="flex flex-col">
                                <div class="flex flex-row justify-end">
                                    <button mat-icon-button type="button"
                                        *ngIf="getFieldFromSection(itemIdKey, field.key)?.fieldValues['IsLocked']"
                                        matTooltip="Unlock Field" class="icon-dropdown-button"
                                        (click)="onLockField(getFieldFromSection(itemIdKey, field.key), false, itemIdKey); $event.stopPropagation()">
                                        <i class="fa-regular fa-lock-open"></i>
                                    </button>
                                    <button mat-icon-button type="button"
                                        *ngIf="getFieldFromSection(itemIdKey, field.key)?.fieldValues['LockEnabled'] && !getFieldFromSection(itemIdKey, field.key)?.fieldValues['IsLocked']"
                                        matTooltip="Lock Field" class="icon-dropdown-button"
                                        (click)="onLockField(getFieldFromSection(itemIdKey, field.key), true, itemIdKey); $event.stopPropagation()">
                                        <i class="fa-regular fa-lock"></i>
                                    </button>
                                    <button mat-icon-button type="button"
                                        *ngIf="getFieldFromSection(itemIdKey, field.key)?.fieldValues['DefaultValueChanged'] && getFieldFromSection(itemIdKey, field.key)?.fieldValues['DefaultValue'] && !getFieldFromSection(itemIdKey, field.key)?.fieldValues['IsLocked']"
                                        matTooltip="Restore Data" class="icon-dropdown-button"
                                        (click)="onRestoreField(getFieldFromSection(itemIdKey, field.key), itemIdKey); $event.stopPropagation()">
                                        <i class="fa-regular fa-rotate-left"></i>
                                    </button>
                                </div>
                                <app-platform-tool-dialog-definition-editor-container
                                    [dialogField]="getFieldFromSection(itemIdKey, field.key)"
                                    [platformDialog]="platformDialogs[itemIdKey][0]" [inputForm]="getSectionForm(itemIdKey)"
                                    (fieldValueChange)="onFieldValueChange($event, getFieldFromSection(itemIdKey, field.key))"
                                    (fieldValidationChange)="onFieldValidationChange($event)"
                                    (fieldDestroy)="onFieldDestroy($event)" [extras]="{}">
                                </app-platform-tool-dialog-definition-editor-container>
                            </div>
                        </td>
                        }
                        }
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </form>
    </div>
    }
    <button type="button" (click)="copySection()" class="action-button"
        matTooltip="Add Section : ({{dialogField.title}})"
        *ngIf="dialogField.fieldValues['IsMultiResponseField'] && !dialogField.fieldValues['IsMultiResponsePage'] && !dialogField.isDisabled"
        mat-button>Add Section
    </button>
</div>
